import { connect } from 'react-redux'
import PayPalAcceptedMethodsComponent from './PayPalAcceptedMethodsComponent/index';

const mapStateToProps = state => ({
    payPalEmail: state.subscription.payPalEmail
});
const PayPalAcceptedMethods = connect(mapStateToProps)(PayPalAcceptedMethodsComponent);

export default PayPalAcceptedMethods;